export default __webpack_public_path__ + "static/media/_bitcoin-btc.88c5f199.svg";